namespace TabAurous.Inventory {
    export interface SortingForm {
        TransId: Serenity.StringEditor;
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        AutoPosting: Serenity.BooleanEditor;
        VoucherNo: Serenity.StringEditor;
        Details: SortingDetailsEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductTypeId: Serenity.IntegerEditor;
        NewProductId: Serenity.LookupEditor;
        LotNo: Serenity.StringEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: StoneSieveLookup;
        QualityId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NewPieces: Serenity.IntegerEditor;
        NewWeight: Serenity.DecimalEditor;
        Rate: Serenity.DecimalEditor;
        GenerateLot: ButtonEditor;
        Clear: ButtonEditor;
        DetailItems: SortingItemsEditor;
        UserId: Serenity.IntegerEditor;
        EmployeeId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
    }

    export class SortingForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.Sorting';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SortingForm.init)  {
                SortingForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = LabelEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.BooleanEditor;
                var w5 = SortingDetailsEditor;
                var w6 = s.LookupEditor;
                var w7 = CommonCategoryLookup;
                var w8 = CommonSubCategoryLookup;
                var w9 = StoneSieveLookup;
                var w10 = s.DecimalEditor;
                var w11 = ButtonEditor;
                var w12 = SortingItemsEditor;

                Q.initFormType(SortingForm, [
                    'TransId', w0,
                    'TransDate', w1,
                    'Posted', w2,
                    'VoucherTypeId', w3,
                    'AutoPosting', w4,
                    'VoucherNo', w0,
                    'Details', w5,
                    'ItemTypeId', w3,
                    'ProductTypeId', w3,
                    'NewProductId', w6,
                    'LotNo', w0,
                    'CategoryId', w7,
                    'SubCategoryId', w8,
                    'StoneSizeId', w6,
                    'SieveId', w9,
                    'QualityId', w6,
                    'ShapeId', w6,
                    'StoneColorId', w6,
                    'Pieces', w3,
                    'Weight', w10,
                    'NewPieces', w3,
                    'NewWeight', w10,
                    'Rate', w10,
                    'GenerateLot', w11,
                    'Clear', w11,
                    'DetailItems', w12,
                    'UserId', w3,
                    'EmployeeId', w3,
                    'CompanyId', w3,
                    'FinancialYearId', w3
                ]);
            }
        }
    }
}
